<template>
  <md-dialog :md-active.sync="isShowReportDialog" :md-close-on-esc="false" :md-click-outside-to-close="false">
    <md-dialog-content>
      <table class="table table-bordered table-striped fixed">
        <thead>
          <tr>
            <th class="name" rowspan="2"></th>
            <th></th>
            <th class="before">作業前</th>
            <th class="minus col2" colspan="2">マイナス</th>
            <th></th>
            <th></th>
            <th class="plus">プラス</th>
            <th class="after col2" colspan="2">作業後</th>
          </tr>
          <tr>
            <th>前回納品後数</th>
            <th class="before">残数</th>
            <th class="minus">ロス個数</th>
            <th class="minus">回収数</th>
            <th>納品予定数</th>
            <th>持ち帰り数</th>
            <th class="plus">実納品数</th>
            <th class="after">納品後個数</th>
            <th class="after">利用数</th>
          </tr>
          <tr>
            <th class="name">合計</th>
            <th class="num">{{totalLastDelivery}}</th>
            <th class="num">{{totalStock}}</th>
            <th class="num">{{totalLoss}}</th>
            <th class="num">{{totalRecall}}</th>
            <th class="num">{{totalPrepare}}</th>
            <th class="num">{{totalTakeout}}</th>
            <th class="num">{{totalActualDelivery}}</th>
            <th class="num">{{totalDeliveryResult}}</th>
            <th class="num">{{totalSales}}</th>
          </tr>
        </thead>
      </table>
      <div class="scroll">
        <table class="table table-bordered table-striped">
          <tbody>
            <ReportTableRow
              v-for="item in normalTemperatureItems"
              :item=item
              :key=item.itemId
              conditionType="normal-temperature"
            >
            </ReportTableRow>
            <ReportTableRow
              v-for="item in refrigeratedItems"
              :item=item
              :key=item.itemId
              conditionType="refrigerated"
            >
            </ReportTableRow>
          </tbody>
        </table>
      </div>
    </md-dialog-content>
    <md-dialog-actions>
      <button class="btn btn-primary btn-block" @click="close">閉じる</button>
    </md-dialog-actions>
  </md-dialog>
</template>


<script>
  import { mapGetters } from 'vuex'
  import ReportTableRow from '@/components/parts/ReportTableRow';

  export default {
    name: 'ReportDialog',
    components: {
      ReportTableRow,
    },
    props: {
      isShowReportDialog: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters([
        'items',
        'quantities',
      ]),
      totalLastDelivery() {
        return this.sum(this.quantities.lastDelivery);
      },
      totalStock() {
        return this.sum(this.quantities.stock);
      },
      totalLoss() {
        return this.sum(this.quantities.loss);
      },
      totalRecall() {
        return this.sum(this.quantities.recall);
      },
      totalPrepare() {
        return this.sum(this.quantities.prepare);
      },
      totalTakeout() {
        return this.sum(this.quantities.takeout);
      },
      totalActualDelivery() {
        return this.totalPrepare - this.totalTakeout;
      },
      totalDeliveryResult() {
        return (this.totalStock - this.totalLoss - this.totalRecall) + this.totalActualDelivery;
      },
      totalSales() {
        return this.totalLastDelivery - this.totalStock;
      },
    },
    data() {
      return {
        normalTemperatureItems: this.$store.getters.items(1),
        refrigeratedItems: this.$store.getters.items(2),
      };
    },
    methods: {
      close() {
        this.$emit('close');
      },
      sum(quantities) {
        if (quantities === undefined) return 0;
        return Object.values(quantities)
          .filter(quantity => quantity !== '')
          .reduce((total, currentValue) => total += currentValue, 0);
      },
    },
  };
</script>
<style lang="scss" scoped>
  $base_col_width: 8%;

  .md-dialog {
    width: 100%;
    height: 100%;

    .md-dialog-content {
      height: 100%;

      .table {
        width: 100%;
        margin-bottom: 0;

        th,
        td {
          width: $base_col_width;

          &.col2 {
            width: $base_col_width * 2;
          }

          &.name {
            width: 28%;
          }
        }

        > thead {
          > tr {
            > th {
              &:not(.name) {
                padding: 0.75rem 0.3rem;
                text-align: center;
              }

              &.name {
                text-align: right;
              }

              &.num {
                text-align: right;
              }

              &.before,
              &.after {
                background: #FDF2D0;
              }

              &.minus {
                background: #D2E2F1;
              }

              &.plus {
                background: #F9E5D0;
              }
            }
          }
        }
      }

      .scroll {
        overflow: auto;
        height: 46%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/globals/ReportDialog.vue?466c4c4c